function hide(element: HTMLElement): void {
    element.style.display = 'none';
}

// ----------------------------------------------------------------------------

export default hide;
